<template>
<div style="height:100%;">
  <w-frame-popup-content-template v-show="!showMessageForm" :default-content="false">
    <div class="frame-table" style="height:100%;padding:25px;" slot="content">
      <w-tool-tabs class="tab-button" style="height:100%;" v-model="currentActiveTab">
        <div slot="tool">
          <el-button type="primary" @click="showSendMessageForm()">쪽지보내기</el-button>
          <el-button @click="deleteMessage">삭제</el-button>
          <w-header-search-button v-show="currentActiveTab === 'receive'" @click="showReceiveSearchTool = !showReceiveSearchTool"></w-header-search-button>
          <w-header-search-button v-show="currentActiveTab === 'send'" @click="showSendSearchTool = !showSendSearchTool"></w-header-search-button>
        </div>
        <el-tab-pane label="받은쪽지함" name="receive">
          <w-receive-message-table style="height:100%;" ref="receiveTable" :current-active-tab="currentActiveTab" :show-search-tool="showReceiveSearchTool" @update-count="updateUnreadMessageCount" @show-send-message-form="showSendMessageForm" />
        </el-tab-pane>
        <el-tab-pane label="보낸쪽지함" name="send">
          <w-send-message-table style="height:100%;" ref="sendTable" :current-active-tab="currentActiveTab" :show-search-tool="showSendSearchTool" />
        </el-tab-pane>
      </w-tool-tabs>
    </div>
  </w-frame-popup-content-template>
  <w-message-form v-show="showMessageForm" ref="messageForm" :manager-id="userInfo.managerId" :show-message-form="showMessageForm" @load-data="loadData" @update-count="updateUnreadMessageCount" @cancel="changeShowMessageFrom" />
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import userApi from '@/api/frame/user';
import WSendMessageTable from './SendMessageTable';
import WReceiveMessageTable from './ReceiveMessageTable';
import WMessageForm from './MessageForm';
import WFramePopupContentTemplate from './FramePopupContentTemplate';

export default {
  name: 'WMessageView',
  components: {
    WSendMessageTable,
    WReceiveMessageTable,
    WMessageForm,
    WFramePopupContentTemplate,
  },
  props: {
    activeTab: {
      type: String,
    },
  },
  data() {
    return {
      showMessageForm: false,
      // defaultActive: 'receive',
      currentActiveTab: 'receive',
      showReceiveSearchTool: false,
      showSendSearchTool: false,
    };
  },
  computed: mapGetters(['userInfo']),
  watch: {
    activeTab(val) {
      if (val === 'message') {
        this.loadData();
      }
    },
  },
  methods: {
    /**
     * 미확인 쪽지 카운트 Update
     * @author kimjy
     */
    updateUnreadMessageCount() {
      userApi.getUnreadMessageCount().then((response) => {
        if (response.data.success) {
          this.$emit('update-unread-message-count', response.data.data);
        }
      });
    },
    showSendMessageForm(message) {
      this.showMessageForm = true;
      this.$nextTick(() => {
        this.$refs.messageForm.initFormData(message);
      });
    },
    changeShowMessageFrom() {
      this.showMessageForm = false;
    },
    loadData() {
      this.$nextTick(() => {
        if (this.currentActiveTab === 'receive') {
          this.$refs.receiveTable.loadData();
        } else {
          this.$refs.sendTable.loadData();
        }
      });
    },
    deleteMessage() {
      this.$nextTick(() => {
        if (this.currentActiveTab === 'receive') {
          this.$refs.receiveTable.deleteReceiveMessage();
        } else {
          this.$refs.sendTable.deleteSendMessage();
        }
      });
    },
    replyMessage() {
      this.$refs.receiveTable.replyMessage();
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/frame/components/popup/MessageView.vue